import { render, staticRenderFns } from "./InfoHud.vue?vue&type=template&id=1fc5870d&"
import script from "./InfoHud.vue?vue&type=script&lang=js&"
export * from "./InfoHud.vue?vue&type=script&lang=js&"
import style0 from "./InfoHud.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports